/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhinternal11Inputs */

const en__field_enum_ikhinternal11 = /** @type {(inputs: _Field_Enum_Ikhinternal11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Internal (via cost center of the Goethe university)`)
};

const de__field_enum_ikhinternal11 = /** @type {(inputs: _Field_Enum_Ikhinternal11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intern (via Kostenstelle der Goethe Universität)`)
};

/**
* | output |
* | --- |
* | "Internal (via cost center of the Goethe university)" |
*
* @param {_Field_Enum_Ikhinternal11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhinternal11 = /** @type {((inputs?: _Field_Enum_Ikhinternal11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhinternal11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhinternal11(inputs)
	return de__field_enum_ikhinternal11(inputs)
});
export { _field_enum_ikhinternal11 as "_field_enum_IKHINTERNAL" }